import React from 'react';
import './ec2PaPreviousCommand.css';

const Ec2PaPreviousCommand = ({command}) => {

  const {
    AccountId,
    CommandComment,
    CommandId,
    CommandStatus,
    DocumentName,
    InstanceIds,
    RequestedDateTime,
    ReviewActionTaken,
    ReviewBy,
    ReviewComment,
    ReviewStatus,
    ReviewTime,
    StatusDetails
  } = command;

  return (
    <div key={CommandId} className={`Ec2PaRequiredAttentionPage ${CommandStatus === 'Success' ? 'Success' : 'NotSuccess'}`}>
      <div>
        <p>Requested Date Time: {RequestedDateTime}</p>
        <p>ID: {CommandId}</p>
        <p>Instance ID: {InstanceIds}</p>
        <p>Account ID: {AccountId}</p>
        <p>Command: {DocumentName} - {CommandComment}</p>
        <p>Status: {CommandStatus}{CommandStatus === StatusDetails ? '' : ` - ${StatusDetails}`}</p>
        {ReviewBy &&
          <React.Fragment>
            <p>Reviewed By: {ReviewBy}</p>
            <p>Review Comment: {ReviewComment}</p>
            <p>Review Time: {ReviewTime}</p>
            <p>Review Status: {ReviewStatus ? ReviewStatus : 'Not Fixed'}</p>
            <p>Review Action Taken: {ReviewActionTaken ? ReviewActionTaken : 'None'}</p>
          </React.Fragment>
        }
      </div>
    </div>
  );

};

export default Ec2PaPreviousCommand;


// WEBPACK FOOTER //
// ./src/components/content/ec2PatchErrors/ec2PaContent/ec2PaRequiredAttention/ec2PaPreviousCommand/ec2PaPreviousCommand.js